module.exports = __webpack_public_path__ + "static/media/Lucy.04529fd6.jpg";